import { RolUsuario } from 'src/app/nucleo/autorizacion/autorizacion.models';
import {
  DisplayFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';

import { ConfiguracionFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import { OPCIONES_TIPO_IDENTIFICACION_FORMULARIO } from 'src/app/compartido/formulario/utilidades/formulario.static';

/* Configuración del formulario de dirección */
export const CONFIGURACION_FORMULARIO_CLIENTE: ConfiguracionFormulario = {
  campos: [
    {
      nombre: 'ID',
      slug: 'id',
      tipo: TipoCampoFormulario.NUMERO,
      readonly: true,
    },
    {
      nombre: 'Organización',
      slug: 'organizacion',
      tipo: TipoCampoFormulario.TEXTO,
      readonly: true,
      roles: [RolUsuario.ELEVA],
    },
    {
      nombre: 'Tipo de Identificación',
      slug: 'tipo_identificacion',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: OPCIONES_TIPO_IDENTIFICACION_FORMULARIO,
      requerido: true,
      readonly: true,
    },
    {
      nombre: 'Identificación',
      slug: 'identificacion',
      tipo: TipoCampoFormulario.NUMERO,
      requerido: true,
      readonly: true,
    },
    {
      nombre: 'Nombre',
      slug: 'nombre',
      tipo: TipoCampoFormulario.TEXTO,
      requerido: true,
    },
    {
      nombre: 'Teléfono Celular',
      slug: 'celular',
      tipo: TipoCampoFormulario.NUMERO,
      telefono: true,
      longitudMinima: 10,
      longitudMaxima: 10,
      requerido: true,
    },
    {
      nombre: 'Teléfono Fijo',
      slug: 'telefono',
      tipo: TipoCampoFormulario.NUMERO,
      telefono: true,
      longitudMinima: 7,
      longitudMaxima: 7,
    },
    {
      nombre: 'Correo',
      slug: 'correo',
      tipo: TipoCampoFormulario.TEXTO,
    },
  ],
  estilo: {
    display: DisplayFormulario.GRID,
  },
};
